<template>
  <div class="background-wrapper">
    <div class="home-wrapper">
      <top-section
        @changeShowVideo="showVideo = $event"
        :showVideo="showVideo"
      />
      <!-- <manual-wrapper /> -->
      <!-- <div class="video-image-wrapper">
        <img
          class="video-image"
          src="@/assets/images/video.png"
          alt=""
          v-show="!showVideo"
        />
        <div class="text-wrapper">
          <h3>{{ $t('main.videoHeader') }}</h3>
          <p>{{ $t('main.videoText') }}</p>
          <div @click="showVideo = true" class="button">
            {{ $t('main.videoButton') }}
          </div>
        </div>
      </div>
      <video
        id="video"
        v-show="showVideo"
        class="video"
        :src="videoSrc"
        controls
      ></video> -->
      <video
        id="video"
        v-show="showVideo"
        class="video"
        :src="videoSrc"
        controls
      ></video>
      <div class="sliders-wrapper">
        <div class="sliders">
          <!-- <slider :category="'home.new'" />
          <slider :category="'home.popular'" />
          <slider :category="'home.sponsored'" /> -->
          <template v-for="(group, index) in groups">
            <div
              v-if="index === 0"
              :key="group.grp_id"
              class="slider-categories-wrapper"
            >
              <div class="categories-wrapper-outer">
                <categories
                  :categories="categories"
                  @changeCategory="changeCategory"
                />
              </div>
              <div class="slider-wrapper-outer">
                <slider :category="group.grp_name" :group="group.grp_id" />
              </div>
            </div>
            <slider
              v-else
              :key="group.grp_id"
              :category="group.grp_name"
              :group="group.grp_id"
            />
          </template>
        </div>
        <div class="baner-wrapper">
          <!-- <div class="baner" style="overflow: hidden;">
            <img src="@/assets/images/banerBird.jpg" alt="baner image" />
          </div> -->
          <!-- <div class="baner">
            <competition-banner  />
          </div> -->
           <router-link
              tag="div"
              class="baner"
              :to="{ name: 'Franchise' }"
            >
              <img src="@/assets/images/franchise.png" alt="baner image" />
          </router-link>
          <div class="baner">
            <img src="@/assets/images/defBanner.png" alt="baner image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { api, baseURL } from "@/api";
import TopSection from "@/components/topSection/topSection.vue";
import Slider from "@/components/slider/slider.vue";
import ManualWrapper from "@/components/manual/manualWrapper.vue";
import Categories from "@/components/topSection/categories.vue";
// import CompetitionBanner from "@/components/competitionBanner.vue";

export default {
  name: "home",
  data() {
    return {
      groups: [],
      categories: null,
      videoSrc: "https://eberza.e-lite.info/video/demo.mp4",
      showVideo: false
    };
  },
  components: {
    TopSection,
    Slider,
    ManualWrapper,
    Categories
    // CompetitionBanner
  },
  metaInfo() {
    return {
      title: this.$i18n.t("main.appName"),
      titleTemplate: "%s | " + this.$i18n.t("main.moto")
    };
  },
  mounted() {
    this.getGroups();
    this.getCategories();

    document.onfullscreenchange = event => {
      let fullscreenElement =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;

      if (fullscreenElement != null) {
      } else {
        this.showVideo = false;
      }
    };
  },
  methods: {
    getGroups() {
      api
        .getGroups()
        .then(res => {
          this.groups = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    changeCategory(category) {
      const query = {
        category: category.cat_id
      };
      this.$router.push({
        name: "Result",
        params: this.$route.params,
        query: query
      });
    },
    getCategories() {
      api
        .getCategories()
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.categories = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getVideoSrc() {
      // console.log(baseURL.replace("api", ""));
      if (this.$route.params.lang === "sr") {
        this.videoSrc = baseURL.replace("api", "") + "video/demo.mp4";
      } else {
        this.videoSrc = baseURL.replace("api", "") + "video/demo-english.mp4";
      }
    }
  },
  watch: {
    "$route.params.lang": {
      handler: function() {
        this.getCategories();
        this.getGroups();
        this.getVideoSrc();
      },
      deep: true,
      immediate: true
    },
    showVideo: {
      handler: function() {
        let element = document.querySelector("#video");
        if (this.showVideo) {
          element.requestFullscreen();
          element.play();
        } else {
          element.pause();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.background-wrapper {
  background: #f2f2f2;
  width: 100%;
}
.home-wrapper {
  margin: 0 auto;
  position: relative;
  max-width: 1320px;
  width: calc(100% - 40px);

  .sliders-wrapper {
    display: flex;
    flex-direction: row;
    margin-bottom: 60px;

    .sliders {
      margin-right: 20px;
      width: calc(100% - 180px);

      .slider-wrapper:last-child {
        margin-bottom: 0px;
      }
    }
    .baner-wrapper {
      width: 160px;
      min-width: 160px;
      height: auto;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;

      .baner {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        overflow: hidden;
        cursor: pointer;

        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .slider-categories-wrapper {
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;

    .categories-wrapper-outer {
      display: none;
    }

    .slider-wrapper-outer {
      width: 100%;
    }
  }
}
@media only screen and (max-width: 1000px) {
  .sliders-wrapper {
    flex-direction: column !important;
  }
  .baner-wrapper {
    margin: 0 auto;
    margin-top: 30px;
    width: 100% !important;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row !important;
    justify-content: space-around;

    .baner {
        width: 160px !important;
    }
  }
  .sliders {
    width: 100% !important;
  }
  .slider-categories-wrapper {
    .categories-wrapper-outer {
      display: block !important;
    }

    .slider-wrapper-outer {
      width: calc(100% - 290px) !important;
    }
  }
}
@media only screen and (max-width: 768px) {
  .sliders-wrapper {
    flex-wrap: wrap;

    .baner-wrapper {
      // margin: 0 auto;
    }
    .sliders {
      margin-right: 0px !important;
      width: 100% !important;
    }
  }
  .slider-categories-wrapper {
    flex-direction: column !important;

    .categories-wrapper-outer {
      margin-bottom: 30px;

      .categories-wrapper {
        width: 100%;
        height: 300px;
      }
    }

    .slider-wrapper-outer {
      width: 100% !important;
    }
  }
}
.video-image {
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.video-image-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  overflow: hidden;
  box-sizing: border-box;
  border: 2px solid #c5c5c5;
  margin-bottom: 25px;

  img {
    filter: brightness(0.65);
  }

  .text-wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      margin-top: 0px;
      margin-bottom: 0px;
      font-family: Open Sans;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 35px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: #ffffff;
    }
    .button {
      width: 127px;
      height: 41px;
      background: #ffffff;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 41px;
      letter-spacing: 0.04em;
      color: #8e3e4c;
      text-transform: uppercase;
      cursor: pointer;
      margin-top: 30px;
      opacity: 0;
      transition-duration: 0.3s;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 17px;
      line-height: 175.9%;
      text-align: center;
      letter-spacing: 0.04em;
      color: #ffffff;
      max-width: 60%;
    }
  }
}
.video-image-wrapper:hover {
  .button {
    opacity: 1;
  }
}
@media only screen and (max-width: 1000px) {
  .video-image {
    height: 300px;
  }
  .video-image-wrapper {
    .text-wrapper {
      margin-top: -15px;
      h3 {
        font-size: 20px;
      }
      p {
        display: none;
      }
      .button {
        margin-top: 10px !important;
        opacity: 1;
      }
    }
  }
}
</style>
